import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ViewerEnum } from 'src/types.d';

const initialState = {
  user: null,
  viewer: ViewerEnum.UNKNOWN,
};

const user = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, { payload }: PayloadAction<any>) {
      state['user'] = payload;
    },

    setViewer(state, { payload }: PayloadAction<any>) {
      state['viewer'] = payload;
    },
  },
});

export const { setUser, setViewer } = user.actions;

export default user.reducer;
